import { API_ENDPOINTS } from "../constants/endpoints";
import api from "../lib/axios";

interface ISearchPayload {
  query: string;
  page: number;
  pageSize: number;
  sort: string;
}

export const getSearchResults = (payload: ISearchPayload) => {
  const { query, page, pageSize, sort } = payload;

  return api.get(
    `${API_ENDPOINTS.GLOBAL_SEARCH.GET_SEARCH_RESULTS}?q=${query}&page=${page}&pageSize=${pageSize}&sort=${sort}`
  );
};
